export default __webpack_public_path__ + "2c0b3d17597d506011d6cfc3c1b06f41.png";